import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "detailed-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon close times",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "path fill",
    d: "M19 6.4L17.6 5L12 10.6L6.4 5L5 6.4L10.6 12L5 17.6L6.4 19L12 13.4L17.6 19L19 17.6L13.4 12L19 6.4Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "org-name" }
const _hoisted_5 = { class: "org-info-wrapper" }
const _hoisted_6 = { class: "org-info" }
const _hoisted_7 = { class: "key" }
const _hoisted_8 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "detailed-view",
    class: _normalizeClass($props.state)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_3),
      _createElementVNode("h2", _hoisted_4, _toDisplayString($props.organization['Organization Name']), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cleanOrganizationData($props.organization), (value, key) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(key) + ":", 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(value), 1)
          ]))
        }), 256))
      ])
    ])
  ], 2))
}